export class DeleteGroupMemberAlertController {
    static $inject = ['close', 'deleteMembers', 'members', 'groupName', '$translate', 'trackGiveUp'];
    constructor(close, deleteMembers, members, groupName, $translate, trackGiveUp) {
        this.close = close;
        this.deleteMembers = deleteMembers;
        this.members = members;
        this.groupName = groupName;
        this.$translate = $translate;
        this.trackGiveUp = trackGiveUp;
        this.name = '';
        this.titleTextSingular = '';
        this.titleTextPlural = '';
        this.bodyTextSingular = '';
        this.bodyTextPlural = '';
        this.buttonTextSingular = '';
        this.buttonTextPlural = '';
        this.isSingular = true;
        this.closeModal = (shouldTrack = true) => {
            if (shouldTrack) {
                this.trackGiveUp(this.members);
            }
            this.close();
        };
        this.onModalChanged = (event) => {
            if (event.detail.modalStatus === 'closed') {
                this.closeModal();
            }
        };
        this.deleteMembersConfirm = async () => {
            this.closeModal(false);
            await this.deleteMembers(this.members);
        };
    }
    async $onInit() {
        this.name = `"${this.groupName}".`;
        this.isSingular = this.members.length === 1;
        this.titleTextSingular = await this.$translate('groups.modals.deleteMember.title.singular');
        this.titleTextPlural = await this.$translate('groups.modals.deleteMember.title.plural');
        this.bodyTextSingular = await this.$translate('groups.modals.deleteMember.body.singular');
        this.bodyTextPlural = await this.$translate('groups.modals.deleteMember.body.plural');
        this.buttonTextSingular = await this.$translate('groups.modals.deleteMember.buttons.keep.singular');
        this.buttonTextPlural = await this.$translate('groups.modals.deleteMember.buttons.keep.plural');
        document
            .getElementById('whatsapp-members-delete-alert')
            .addEventListener('bdsModalChanged', this.onModalChanged);
    }
}
DeleteGroupMemberAlertController.$inject = ['close', 'deleteMembers', 'members', 'groupName', '$translate', 'trackGiveUp'];
